import {FC} from "react";
import {Link, Outlet} from "react-router-dom";
import { Icon } from "assets/Icon";
import "./EmptyPageLayout.scss";

type EmptyPageLayoutProps = {
  isWhite?: boolean;
}

export const EmptyPageLayout: FC<EmptyPageLayoutProps> = ({ isWhite=false }) => (
  <div className={`EmptyPageLayout${isWhite ? ' isWhite' : ''}`}>
    <div className="EmptyPageLayout-Logo">
      <Link to="/">
        <Icon name="logo3" className="autoSize" />
      </Link>
    </div>
    <div className="EmptyPageLayout-body">
      <Outlet />
    </div> 
  </div>
);
